<template>
  <div class="jin-zp-process">
    <div v-for="(item,index) in processArr" :key="index" class="jin-zp-process-item">
      <div class="img-wrap">
        <img class="process-img" :src="item.img" alt="">
        <img v-if="index!==4" class="right-arrow" src="~@/assets/zpProcess/三角形@2x.png" alt="">
      </div>
      <div class="title">{{ item.title }}</div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      processArr: [
        {
          title: '网申',
          img: require('@/assets/zpProcess/网申@2x.png')
        },
        {
          title: '简历筛选',
          img: require('@/assets/zpProcess/筛选@2x.png')
        },
        {
          title: '面试',
          img: require('@/assets/zpProcess/面试@2x.png')
        },
        {
          title: 'offer',
          img: require('@/assets/zpProcess/offer@2x.png')
        },
        {
          title: '入职',
          img: require('@/assets/zpProcess/入职@2x.png')
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.jin-zp-process {
  display: flex;
  width: 100%;
  height: 158px;
  margin: 38px auto 4px;
  padding: 0 32px 0 27px;
  .jin-zp-process-item {
    width: 201px;
    height: 100%;
    margin-right: 80px;
    .img-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;;
      width: 100%;
      height: 98px;
      margin-bottom: 31px;
      .process-img {
        width: 98px;
        height: 98px;
      }
      .right-arrow {
        width: 18px;
        height: 22px;
      }
    }
    .title {
      width: 98px;
      height: 100%;
      line-height: 100%;
      text-align: center;
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      color: #3D4351;
    }
    &:last-child {
      width: 98px;
      margin-right: 0;
    }
  }
}
@media screen and (max-width: 768px) {
.jin-zp-process {
  display: flex;
  justify-content: space-between;
  width: auto;
  height: 59px;
  margin: 18px auto 8px;
  padding: 0 20px;
  .jin-zp-process-item {
    position: relative;
    width: 56px;
    height: 100%;
    margin-right: 11px;
    .img-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;;
      width: 100%;
      height: 36px;
      margin-bottom: 7px;
      .process-img {
        width: 36px;
        height: 36px;
      }
      .right-arrow {
        width: 5px;
        height: 7px;
      }
    }
    .title {
      width: auto;
      height: 16px;
      font-size: 11px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 400;
      color: #3D4351;
      line-height: 16px;
      text-align: left;
      padding-left: 7px;
    }
    &:nth-child(2) .title {
      position: absolute;
      left: -10px;
      bottom: 0;
    }
    &:last-child {
      width: 36px;
      margin-right: 0;
    }
  }
}
}
</style>
